// src/App.jsx
import { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router";
import { Toaster } from "sonner";
import "./index.css";
import LandingPage from "./pages/auth/Landing";
import SignUpPage from "./pages/auth/SignUp";
import SignInPage from "./pages/auth/SignIn";
import SchoolSignInPage from "./pages/auth/SchoolSignIn";
import SchoolSignUpPage from "./pages/auth/SchoolSignUp";
import DashboardPage from "./pages/Dashboard";
import CareerAssessmentPage from "./pages/CareerAssessment";
import Assessmentspage from "./pages/Assessments";
import CareerLearningPathPage from "./pages/CareerLearningPath";
import CareerPathPage from "./pages/CareerPath";
import CareerExplorerPage from "./pages/CareerExplorer";
import LearningResourcesPage from "./pages/LearningResources";
import GoalsPage from "./pages/Goals";
import AchievementsPage from "./pages/Achievements";
import AICompanionPage from "./pages/AI-Companion";
import ProfilePage from "./pages/Profile";
import SettingsPage from "./pages/Settings";
import CurriculumPage from "./pages/Curriculum";
// JourneyPage hidden — not ready for production (videos/content pending)
import NotificationsPage from "./pages/Notifications";
import SchoolDashboardPage from "./pages/SchoolDashboard";
import StudentsManagementPage from "./pages/StudentsManagement";
import StudentOverviewPage from "./pages/StudentOverview";
import SchoolResourcesPage from "./pages/SchoolResources";
import AssessmentManagementPage from "./pages/AssessmentManagement";
import ClassManagementPage from "./pages/ClassManagement";
import SubjectManagementPage from "./pages/SubjectManagement";
import AdminManagementPage from "./pages/AdminManagement";
import DataCenterPage from "./pages/DataCenter";
import ReportCenterPage from "./pages/ReportCenter";
import AnalyticsPage from "./pages/Analytics";
import ClassOverviewPage from "./pages/ClassOverview";
import SchoolSettingsPage from "./pages/SchoolSettings";
import GamesPage from "./pages/Games";
const MatchGame         = lazy(() => import("./pages/games/MatchGame"));
const BudgetBlitz       = lazy(() => import("./pages/games/BudgetBlitz"));
const CapitalsScramble  = lazy(() => import("./pages/games/CapitalScramble"));
const CivicSpin         = lazy(() => import("./pages/games/CivicSpin"));
const CompoundConnector = lazy(() => import("./pages/games/CompoundConnector"));
const BiologyKingdom    = lazy(() => import("./pages/games/BiologyKingdom"));
const DiplomatsDesk     = lazy(() => import("./pages/DiplomatsDesk"));
const WordSmith         = lazy(() => import("./pages/games/WordSmith"));
const NairaTycoon       = lazy(() => import("./pages/games/NairaTycoon"));
const FixItChallenge    = lazy(() => import("./pages/games/FixItChallenge"));
const EquationScape     = lazy(() => import("./pages/games/EquationScape"));
import AdminDashboard from "./pages/superadmin/AdminDashboard"
import SchoolsManagement from "./pages/superadmin/SchoolsManagement"
import SchoolDetail from "./pages/superadmin/SchoolDetail"
import UsersManagement from "./pages/superadmin/UsersManagement"
import AuditLogPage from "./pages/superadmin/AuditLogPage"
import { AdminLogin } from "./pages/auth/AdminLogin"
import PsychometricAssessment from "./pages/assessment/PsychometricAssessment"
import BroadPathSelection from "./pages/assessment/BroadPathSelection"
import AssessmentResults from "./pages/assessment/AssessmentResults"
import TakeAssessment from "./pages/assessment/TakeAssessment"
import MicroCoursePage from "./pages/courses/MicroCoursePage"
import ActivityLogger from "./pages/activities/ActivityLogger"
import StudentInsightsPage from "./pages/StudentInsights"
import ParentPortalPage from "./pages/ParentPortal"
import ParentSignInPage from "./pages/auth/ParentSignIn"
import ForgotPasswordPage from "./pages/auth/ForgotPassword"
import ResetPasswordPage from "./pages/auth/ResetPassword"
import ActivateParentPage from "./pages/auth/ActivateParent"
import OnboardingWizard from "./pages/onboarding/OnboardingWizard"
import MentorManagementPage from "./pages/MentorManagement"
import EventManagementPage from "./pages/EventManagement"
import LeaderboardPage from "./pages/Leaderboard"
import DailyChallengePage from "./pages/DailyChallenge"
import SkillGapPage from "./pages/SkillGap"
import CVBuilderPage from "./pages/CVBuilder"
import CareerRoadmapPage from "./pages/CareerRoadmap"
import CertificatesPage from "./pages/Certificates"
import MentorBookingPage from "./pages/MentorBooking"
import PortfolioPage from "./pages/Portfolio"

import { AIChatBox } from "@/components/ui/ai-chat-box"
import { AuthStore } from "@/hooks/stores/AuthStore"
import { useStudentSync } from "@/hooks/useStudentSync"

function App() {
  const isLoggedIn = AuthStore((s) => s.isLoggedIn)
  useStudentSync()

  return (

      <div
        className="min-h-screen"
        style={{ backgroundColor: "var(--theme-background)" }}
      >
        <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="w-8 h-8 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin" /></div>}>
        <Routes>

          <Route index path="/" element={<LandingPage />} />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
          <Route path="/activate-parent" element={<ActivateParentPage />} />
          <Route path="/school/signin" element={<SchoolSignInPage />} />
          <Route path="/school/signup" element={<SchoolSignUpPage />} />
         
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/career-assessment" element={<CareerAssessmentPage />} />
          <Route path="/assessments" element={<Assessmentspage />} />
          <Route
            path="/career-learning-path"
            element={<CareerLearningPathPage />}
          />
          <Route path="/career-path" element={<CareerPathPage />} />
          <Route path="/career-explorer" element={<CareerExplorerPage />} />
          <Route
            path="/learning-resources"
            element={<LearningResourcesPage />}
          />
          <Route path="/goals" element={<GoalsPage />} />
          <Route path="/achievements" element={<Navigate to="/goals" replace />} />
          <Route path="/ai-companion" element={<AICompanionPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/curriculum" element={<Navigate to="/career-explorer" replace />} />
          <Route path="/journey" element={<Navigate to="/career-explorer" replace />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/school-dashboard" element={<SchoolDashboardPage />} />
          <Route
            path="/students-management"
            element={<StudentsManagementPage />}
          />
          <Route path="/school-resources" element={<SchoolResourcesPage />} />
          <Route
            path="/assessment-management"
            element={<AssessmentManagementPage />}
          />
          <Route path="/class-management" element={<ClassManagementPage />} />
          <Route path="/class-management/:id" element={<ClassOverviewPage />} />
          <Route path="/students-management/:id" element={<StudentOverviewPage />} />
          <Route
            path="/subject-management"
            element={<SubjectManagementPage />}
          />
          <Route path="/admin-management" element={<AdminManagementPage />} />
          <Route path="/data-center" element={<DataCenterPage />} />
          <Route path="/reports-center" element={<ReportCenterPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/school-settings" element={<SchoolSettingsPage />} />
          <Route path="/games" element={<GamesPage />}>
            <Route path="match-game" element={<MatchGame />} />
          </Route>
          <Route path="/budget-blitz" element={<BudgetBlitz />} />
          <Route path="/capital-scramble" element={<CapitalsScramble />} />
          <Route path="/civic-spin" element={<CivicSpin />} />
          <Route path="/compound-connector" element={<CompoundConnector />} />
          <Route path="/biology-kingdom" element={<BiologyKingdom />} />
          <Route path="/diplomats-desk" element={<DiplomatsDesk />} />
          <Route path="/wordsmith" element={<WordSmith />} />
          <Route path="/naira-tycoon" element={<NairaTycoon />} />
          <Route path="/fixit-challenge" element={<FixItChallenge />} />
          <Route path="/equation-scape" element={<EquationScape />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/schools" element={<SchoolsManagement />} />
          <Route path="/admin/schools/:id" element={<SchoolDetail />} />
          <Route path="/admin/users" element={<UsersManagement />} />
          <Route path="/admin/audit" element={<AuditLogPage />} />
          <Route path="/psychometric-assessment" element={<PsychometricAssessment />} />
          <Route path="/broad-path-selection" element={<BroadPathSelection />} />
          <Route path="/assessment-results" element={<AssessmentResults />} />
          <Route path="/take-assessment" element={<TakeAssessment />} />
          <Route path="/course/:courseId" element={<MicroCoursePage />} />
          <Route path="/activity-log" element={<ActivityLogger />} />
          <Route path="/student-insights" element={<StudentInsightsPage />} />
          <Route path="/parent" element={<ParentPortalPage />} />
          <Route path="/parent/signin" element={<ParentSignInPage />} />
          <Route path="/onboarding" element={<OnboardingWizard />} />
          <Route path="/mentor-management" element={<MentorManagementPage />} />
          <Route path="/event-management" element={<EventManagementPage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/daily-challenge" element={<DailyChallengePage />} />
          <Route path="/skill-gap" element={<SkillGapPage />} />
          <Route path="/cv-builder" element={<CVBuilderPage />} />
          <Route path="/career-roadmap" element={<CareerRoadmapPage />} />
          <Route path="/certificates" element={<CertificatesPage />} />
          <Route path="/mentors" element={<MentorBookingPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
        </Routes>
        </Suspense>
        {isLoggedIn && <AIChatBox />}
        <Toaster position="bottom-right" richColors />
      </div>

  );
}

export default App;
